import { Component, input, output } from '@angular/core'
import { EntityFieldComponent } from './entity-field.component'
import { Option } from '../shared/models/general'

@Component({
  selector: 'app-entity-select-field',
  imports: [
    EntityFieldComponent,
  ],
  template: `
    <div
        app-entity-field
        [id]="id()"
        [label]="label()"
        [validationMessage]="validationMessage()"
    >
      <select class='form-select' (change)="onChange($event)">
        @if (!value()) {
          <option value='' [selected]="true"></option>
        }
        @for (o of options(); track o.value) {
          <option [value]="o.value" [selected]="value() === o.value">{{ o.display }}</option>
        }
      </select>
    </div>
  `,
})
export class EntitySelectFieldComponent<T = string> {
  readonly id = input.required<string>()
  readonly label = input.required<string>()
  readonly options = input.required<readonly Option<T>[]>()
  readonly value = input.required<T | undefined>()
  readonly validationMessage = input<string>()

  readonly valueChange = output<T | undefined>()

  protected onChange(event: Event) {
    const value: string | undefined = (event.target as HTMLSelectElement).value || undefined
    const option = value ? this.options().find(_ => String(_.value) === value) : undefined
    this.valueChange.emit(option?.value)
  }
}
